import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { rememberReferralCode } from './utils/referral'
import './index.css'
import BootRoot from './routing/BootRoot'
import { isGlassesMode } from './lib/glassesMode'
import StorageNotice from './components/StorageNotice'

// The lens HUD has no repeated navigation or #main-content target.
const skipLink = document.querySelector<HTMLAnchorElement>('.skip-link')
if (skipLink) skipLink.hidden = isGlassesMode()
rememberReferralCode()

// A stale tab can reference lazy chunks removed by a deployment. Reload once,
// throttled, to fetch the new manifest instead of presenting a blank page.
if (import.meta.env.PROD) {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    try {
      const KEY = 'smg:preload-error-reload';
      const last = Number(sessionStorage.getItem(KEY) || 0);
      if (Date.now() - last > 10_000) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  });
}

// Register after load; the worker never blocks first paint.
if (
  'serviceWorker' in navigator
  && import.meta.env.PROD
  && !/(?:Capacitor|CapacitorWebView)/i.test(navigator.userAgent)
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        const checkForUpdate = () => { reg.update().catch(() => {}); };
        window.addEventListener('focus', checkForUpdate);
        setInterval(checkForUpdate, 60 * 60 * 1000);
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              window.location.reload();
            }
          });
        });
      })
      .catch((err) => console.warn('[pwa] service worker registration failed:', err));
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><BootRoot />{!isGlassesMode() && <StorageNotice />}</StrictMode>,
);